import { weeklyRoundup } from "@/mocks/home";

const statusStyle: Record<string, string> = {
  brand: "bg-secondary-100 text-secondary-900",
  new: "bg-accent-100 text-accent-700",
  statement: "bg-primary-100 text-primary-700",
  pending: "bg-background-200 text-foreground-700",
};

export default function Roundup() {
  return (
    <section id="roundup" className="w-full border-b border-background-200 bg-background-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-10">
          <div className="lg:col-span-4">
            <p className="text-xs font-medium tracking-widest text-accent-600">WEEKLY LIST</p>
            <h2 className="mt-2 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              黑料看料一览 · 本周清单
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              把这一周新增、更新与有回应的条目排成一张清单，按日期从近到远，一眼看完最新动向。
            </p>

            <div className="mt-6 rounded-lg border border-background-200 bg-background-50 p-4">
              <div className="flex items-center gap-2 text-xs text-foreground-600">
                <i className="ri-filter-3-line text-sm" />
                状态说明
              </div>
              <ul className="mt-3 space-y-2 text-xs">
                <li className="flex items-center gap-2">
                  <span className="rounded-full bg-accent-100 px-2 py-0.5 text-accent-700">新增线索</span>
                  <span className="text-foreground-600">刚被整理出来的信息</span>
                </li>
                <li className="flex items-center gap-2">
                  <span className="rounded-full bg-primary-100 px-2 py-0.5 text-primary-700">双方发声</span>
                  <span className="text-foreground-600">当事双方均有公开回应</span>
                </li>
                <li className="flex items-center gap-2">
                  <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-secondary-900">已核实</span>
                  <span className="text-foreground-600">公开物料可直接对照</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="lg:col-span-8">
            <ul className="divide-y divide-background-200 border-y border-background-200">
              {weeklyRoundup.map((item, idx) => (
                <li key={`${item.date}-${idx}`}>
                  <a
                    href="#entry"
                    className="group flex items-center gap-4 py-3.5 transition-colors hover:bg-background-50 cursor-pointer"
                  >
                    <time className="hidden w-14 shrink-0 font-heading text-sm text-foreground-500 sm:block">
                      {item.date}
                    </time>
                    <span className="min-w-0 flex-1">
                      <span className="block text-sm md:text-[15px] text-foreground-900 group-hover:text-primary-700">
                        {item.title}
                      </span>
                      <span className="mt-1 flex items-center gap-2 sm:hidden">
                        <span className="text-xs text-foreground-500">{item.date}</span>
                      </span>
                    </span>
                    <span
                      className={`shrink-0 rounded-full px-2.5 py-0.5 text-xs ${
                        statusStyle[item.status] ?? statusStyle.pending
                      }`}
                    >
                      {item.type}
                    </span>
                    <span className="hidden w-24 shrink-0 items-center gap-2 md:flex">
                      <span className="h-1 flex-1 overflow-hidden rounded-full bg-background-300">
                        <span
                          className="block h-full rounded-full bg-foreground-700"
                          style={{ width: `${item.heat}%` }}
                        />
                      </span>
                      <span className="text-xs text-foreground-500">{item.heat}</span>
                    </span>
                  </a>
                </li>
              ))}
            </ul>

            <a
              href="#entry"
              className="mt-6 inline-flex items-center gap-1.5 text-sm font-medium text-foreground-700 hover:text-primary-600 whitespace-nowrap cursor-pointer"
            >
              查看更多收录条目
              <i className="ri-arrow-right-line" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}